import { render, staticRenderFns } from "./PaymentsReports.vue?vue&type=template&id=6eb6823f&scoped=true&"
import script from "./PaymentsReports.vue?vue&type=script&lang=js&"
export * from "./PaymentsReports.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsReports.vue?vue&type=style&index=0&id=6eb6823f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb6823f",
  null
  
)

export default component.exports